import { css, unsafeCSS } from 'lit';
import SotbitButton from '../button';
import styles from './button-widget.scss?inline';

export default class SotbitButtonWidget extends SotbitButton {
    static styles = [
        SotbitButton.styles,
        css`
            ${unsafeCSS(styles)}
        `,
    ];
}
